export const DOWNLOADABLE_FILES_POLLING_DELAY = Number(
  process.env.REACT_APP_DOWNLOADABLE_FILES_POLLING_DELAY_IN_MS,
);
